import { lazy } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { historikYear, monthFromSlug, monthLabel } from "@/hooks/useHistoricalPrices";

const ElpriserHistorikManad = lazy(() => import("@/pages/elpriser/HistorikManad"));

export const Route = createFileRoute("/elpriser/historik/$yearSlug/$month")({
  // Okänt år eller månad: riktig 404 (sidan skickade annars vidare först i webbläsaren).
  beforeLoad: ({ params }) => {
    if (!historikYear(params.yearSlug) || !monthFromSlug(params.month)) throw notFound();
  },
  head: ({ params }) => {
    const year = String(params.yearSlug).replace(/^elpriser-/, "");
    const month = monthFromSlug(params.month);
    const label = month ? monthLabel(month) : "";
    return seoHead(`/elpriser/historik/${params.yearSlug}/${params.month}`, {
      ...(label
        ? {
            description: `Elpriser i ${label} ${year}: dagliga spotpriser per elområde SE1–SE4, månadsmedelpris och jämförelse med samma månad tidigare år.`,
          }
        : {}),
    });
  },
  component: () => <ElpriserHistorikManad />,
});
